var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLargePackageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 80,
    viewBox: "0 0 73 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.1006 30.0028L19.0336 10.3574",
    stroke: "#E4E4E7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1341 54.9854V24.7036C70.1328 23.376 69.7823 22.0722 69.1179 20.9228C68.4536 19.7734 67.4986 18.819 66.3489 18.1552L39.8523 3.01425C38.7014 2.3498 37.396 2 36.0671 2C34.7382 2 33.4327 2.3498 32.2818 3.01425L5.78523 18.1552C4.63551 18.819 3.68057 19.7734 3.01619 20.9228C2.35181 22.0722 2.00136 23.376 2 24.7036V54.9854C2.00136 56.313 2.35181 57.6169 3.01619 58.7663C3.68057 59.9156 4.63551 60.8701 5.78523 61.5339L32.2818 76.6748C33.4327 77.3393 34.7382 77.6891 36.0671 77.6891C37.396 77.6891 38.7014 77.3393 39.8523 76.6748L66.3489 61.5339C67.4986 60.8701 68.4536 59.9156 69.1179 58.7663C69.7823 57.6169 70.1328 56.313 70.1341 54.9854Z",
    stroke: "#E4E4E7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02197 20.7676L36.067 39.883L69.1121 20.7676",
    stroke: "#E4E4E7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.067 77.9998V39.8447",
    stroke: "#E4E4E7",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargePackageIcon);
export default __webpack_public_path__ + "static/media/large-package-icon.303e37abf3a8e520eda72452be50f817.svg";
export { ForwardRef as ReactComponent };